// extracted by mini-css-extract-plugin
export default {"userMenu":"UD7OIFgwF1LOfPJP234A","login":"jWfqKg10xvcVZqMUgbLQ","logout":"V05WfzCpIdOS1YlQd1Hq","profilePic":"cNjqYzfITmntvsDuBdU8"};